/* ============
 * Getters for the auth module
 * ============
 *
 * The getters that are available on the
 * auth module.
 */

export default {
  authenticated(state) {
    return state.authenticated;
  },
};
